<template>
  <div>
    <b-card class="md-3">
     <div id="b-card-title">{{ title }}</div>
      <b-card-text>
        Some quick example text to build on the card title.
      </b-card-text>
    </b-card>
  </div>
</template>


<script>
export default {
    props: {
      title: String,
      size: String
    }
}
</script>
